import useStore from "../store"
import { Outlet } from "react-router-dom"
import MessageHandling from "./MessageHandling/MessageHandling"
import Login from "./Login"
import NavBar from "./NavBar/NavBar"
import { ErrorBoundary } from "@rollbar/react"
import ErrorDisplay from "./ErrorDisplay"

export default function Root() {
  const user = useStore((state) => state.user)

  return(
    <ErrorBoundary fallbackUI={ErrorDisplay}>
      <MessageHandling>
        <NavBar>
          {user ? <Outlet /> : <Login />}
        </NavBar>
      </MessageHandling>
    </ErrorBoundary>
  )
}